import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { toast } from "react-toastify";
import { CustomerGrid, ServiceThreadSpinner } from '.';
import { api, constants, helpers } from '../utils';

export default function OnHoldLateBalanceCustomers(props) {
   const [data, setData] = useState();
   const [loaded, setLoaded] = useState(false);
   const [overdue, setOverdue] = useState(false);
   const [salespersonId, setCustomerId] = useState(props.salespersonId)
   const [sortDirection, setSortDirection] = useState("asc");
   const [sortField, setSortField] = useState("CustomerId");

   useEffect(() => {
      if (props.salespersonId !== salespersonId) {
         setCustomerId(props.salespersonId);
         setLoaded(false);
      }
      if (!loaded) {
         loadData();
      }
      // below line stops the "React Hook useEffect has missing dependencies" eslint error
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [loaded, props.salespersonId])

   useEffect(() => {
      loadData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [overdue])

   function createPayload() {
      return {
         SortField: sortField,
         SortDirection: sortDirection,
         CustomerId: '',
         SalesPersonId: props.salespersonId,
         ShowOnHoldOnly: props.showOnHoldOnly,
         ShowLateBalancesOnly: props.showLateBalancesOnly,
         ShowPastDue: overdue,
         City: '',
         State: ''
      }
   }

   function exportXlsx() {
      const payload = createPayload()
      api
         .postGetBlob("Customer/ExportOnHoldLateBalanceCustomersXLSX", payload)
         .then(r => {
            if (r.data.success === false) {
               if (_.isString(r?.data?.message)) {
                  toast.error(r?.data?.message);
               }
               return;
            }
            if (r.data) {
               const XLSX_FILENAME = payload.SalesPersonId
                  ? `${payload.SalesPersonId}_${payload.ShowLateBalancesOnly ? "Late_Customers" : "Hold_Customers"}.xlsx`
                  : `${payload.ShowLateBalancesOnly ? "Late_Customers" : "Hold_Customers"}.xlsx`
               helpers.downloadExport(r.data, XLSX_FILENAME, constants.MIME_TYPES.xlsx)
            } else {
               toast.error(r.message || "Error downloading report");
            }
         })
         .catch(api.catchHandler);
   }

   function loadData() {
      api
         .post(`Customer/GetCustomers`, createPayload())
         .then(response => {
            if (response.data.success) {
               setData(response.data.onHoldCustomers)
               // setTotalPages(_.ceil(response.data.orders.totalCount / 10));
               // setTotals(response.data.totals);
            }
            setLoaded(true)
         })
         .catch(api.catchHandler);
   }

   function onSortChange(field, direction) {
      if (field !== sortField) {
         setSortField(field);
         setSortDirection("asc")
      } else {
         setSortDirection(direction);
      }
      setLoaded(false);
      // onPageChange(1);
   }

   function setOverdueVal(val) {
      setOverdue(val);
   }

   return (
      <>
         <div>
            <span className="h2 me-2">{props.showOnHoldOnly ? `On Hold Customers` : `30+ Balance Customers`}</span> <span className="text-muted"></span>
         </div>
         <hr />
         <ServiceThreadSpinner on={!loaded}>
            {data && data.length
               ? <CustomerGrid
                  data={data}
                  // totals={totals}
                  sortCallback={onSortChange}
                  sortField={sortField}
                  sortDirection={sortDirection}
                  setOverdueCallback={setOverdueVal}
                  overdueRows={overdue}
                  // pagerCallback={onPageChange}
                  // pageNumber={page}
                  // totalPages={totalPages}
                  exportXlsxCallback={exportXlsx}
                  showOnHoldOnly={props.showOnHoldOnly}
                  showLateBalancesOnly={props.showLateBalancesOnly}
               />
               : <span className="h5" style={{ color: "red" }}>No on hold customers found</span>
            }
         </ServiceThreadSpinner>
      </>
   )
}